// eslint-disable-next-line import/extensions
import YKcMessage from './src/main.js';

export default YKcMessage;
